module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "logo-5.be418d14.svg";